<template>
  <div class="container">
    <div class="search">
      <van-search
        v-model="params.keyword"
        placeholder="请输入企业名称"
        shape="round"
        @search="getStatistics"
      />
      <div class="search-filter" @click="showPop = true">
        <van-icon name="filter-o" />
        <span>筛选</span>
      </div>
    </div>
    <van-tabs
      animated
      color="#ea9052"
      @click="chooseTab"
      custom-class="vantabs"
    >
      <van-tab title="存料统计" name="GOLD"></van-tab>
      <van-tab title="余额统计" name="CNY"></van-tab>
    </van-tabs>
    <div class="list">
      <van-list>
        <div class="list-item">
          <div class="list-item-title">合计</div>
          <ve-table
            :columns="columns"
            :table-data="totalData"
            :cell-style-option="cellStyleOption"
          />
        </div>
        <Card
          v-for="item in tableData"
          :key="item.id"
          :data="item"
          :currency="params.currency"
        />
      </van-list>
    </div>

    <van-popup
      v-model="showPop"
      position="bottom"
      :style="{ height: '140px', paddingTop: '16px' }"
      closeable
      round
    >
      <div
        style="margin: 0 auto; text-align: left; font-size: 18px"
        class="account_title"
      >
        账户类型：
      </div>
      <div class="popup">
        <Boxgroup v-model="params.userType" solo>
          <Box label="全部" value="" />
          <Box label="个人" value="PERSON" />
          <Box label="企业" value="COMPANY" />
        </Boxgroup>
      </div>
      <div class="btns">
        <van-button plain @click="restFilter">重置</van-button>
        <van-button color="#ea9052" @click="submitFilter">确定</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Boxgroup from "@/components/Boxgroup";
import Box from "@/components/Boxgroup/Box";
import Card from "./Card";
import { getStatisticsApi } from "@/api/statistics";
export default {
  components: {
    Boxgroup,
    Box,
    Card,
  },
  watch: {
    "params.currency": {
      handler(newval, old) {
        if (newval === "GOLD") {
          this.$set(this.columns, 0, { ...this.columns[0], title: "账户金料" });
          this.$set(this.columns, 1, { ...this.columns[1], title: "冻结金料" });
          this.$set(this.columns, 2, { ...this.columns[2], title: "可用金料" });
        } else {
          this.$set(this.columns, 0, { ...this.columns[0], title: "账户余额" });
          this.$set(this.columns, 1, { ...this.columns[1], title: "冻结余额" });
          this.$set(this.columns, 2, { ...this.columns[2], title: "可用余额" });
        }
      },
    },
  },
  created() {
    this.getPhone();
    this.getStatistics();
  },
  data() {
    return {
      totalData: [],
      columns: [
        {
          field: "balance",
          key: "a",
          title: "账户金料",
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            console.log(this.params.currency, "ccc");

            return (
              <span>
                {this.params.currency == "GOLD"
                  ? row.balance.toFixed(2) + "g"
                  : row.balance.toFixed(2) + "元"}
              </span>
            );
          },
        },
        {
          field: "freezeAmount",
          key: "b",
          title: "冻结金料",
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {this.params.currency === "GOLD"
                  ? row.freezeAmount.toFixed(2) + "g"
                  : row.freezeAmount.toFixed(2) + "元"}
              </span>
            );
          },
        },
        {
          field: "availableAmount",
          key: "c",
          title: "可用金料",
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {this.params.currency === "GOLD"
                  ? row.availableAmount.toFixed(2) + "g"
                  : row.availableAmount.toFixed(2) + "元"}
              </span>
            );
          },
        },
      ],
      tableData: [],
      value: "",
      showPop: false,
      type: "",
      loading: false,
      finished: true,
      params: {
        currency: "GOLD",
        userType: "",
        keyword: "",
        phone: "",
      },
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          return "header-cell";
        },
        bodyCellClass: ({ row, col }) => {
          return "body-cell";
        },
      },
    };
  },

  methods: {
    getPhone() {
      this.params.phone = window.localStorage.getItem("phoneNumber");
    },
    getStatistics() {
      getStatisticsApi(this.params).then((res) => {
        this.totalData = [res.data.data.total];
        this.tableData = res.data.data.list;
      });
    },
    submitFilter() {
      this.getStatistics();
      this.showPop = false;
    },
    restFilter() {
      this.params.userType = "";
      this.getStatistics();
      this.showPop = false;
    },
    chooseTab(name) {
      this.params.currency = name;
      this.getStatistics();
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .van-tabs__nav--card {
  margin: 0;
}
::v-deep .van-search {
  padding: 0;
  background-color: unset;
  flex: 1;
}
::v-deep .van-button--normal {
  width: 50%;
  height: 100%;
}
::v-deep .van-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
::v-deep .van-tabs__wrap {
  height: 60px !important;
}
::v-deep .header-cell {
  background: #f7f9ff !important;
  color: #333333 !important;
  height: 64px;
  font-size: 26px !important;
}
::v-deep .body-cell {
  height: 64px !important;
  color: #000000 !important;
  font-size: 26px !important;
}
.account_title {
  margin-left: 28px !important;
}
.container {
  background-color: #f5f5f5;
  width: 100%;
  min-height: 100vh;
  .search {
    width: 100%;
    background-color: #f5f5f5;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 88px;
    background-color: #ffffff;
    padding: 20px 40px;
    margin-top: 12px;
    &-filter {
      padding-left: 20px;
      box-sizing: border-box;
    }
  }
  .list {
    padding: 0 20px;
    margin-top: 24px;
    &-item {
      border-radius: 24px;
      width: 100%;

      background-color: #ffffff;
      padding: 32px;

      &-title {
        margin-bottom: 24px;
      }
    }
  }
  .popup {
    margin-top: 40px;
    margin-left: 40px;
  }
  .btns {
    position: absolute;
    bottom: 0;
    height: 70px;
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
}
</style>
